import { render, staticRenderFns } from "./AddressApprovalWarning.vue?vue&type=template&id=0ce93f0f&"
import script from "./AddressApprovalWarning.vue?vue&type=script&lang=js&"
export * from "./AddressApprovalWarning.vue?vue&type=script&lang=js&"
import style0 from "./AddressApprovalWarning.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports